/* eslint-disable @typescript-eslint/ban-ts-comment */
import type {
  PressureTraverseChartContext,
  PressureTraverseChartData
} from "./d";
import type { ScenarioCalculations } from "@/composables/scenarioCalculations/calculationTypes";
import { getPressureTraverseDataset } from "./getPressureTraverseDataset";
import type { ConvertableUnit } from "@/libs/units";

const buildPressureTraverseChartContext = (
  calcs: ScenarioCalculations,
  targetPressureUnit: ConvertableUnit,
  targetLargeLengthUnit: ConvertableUnit
): PressureTraverseChartContext => {
  // @ts-ignore
  const wellProperties = calcs.destructuredScenario.wellProperties?.value;
  const context: PressureTraverseChartContext = {
    targetPressureUnit,
    targetLargeLengthUnit,
    bottomTubingPressurePSIA: calcs.basicData.value.bottomTubingPressurePSIA,
    requiredDischargePressurePSIA:
      calcs.pumpCalculations.aggregate.requiredDischargePressurePSIA.value,
    completePumpDepthFt: calcs.equipmentLengths.completePumpDepthFt.value,
    pumpIntakePressurePSIA: calcs.pumpIntakePressurePSIA.value,
    wellFlowingPressureAtPerfsPSIA: calcs.wellFlowingPressureAtPerfsPSIA.value,
    topOfPerforationsMeasuredDepthFeet:
      wellProperties.top_of_perforations_measured_depth_feet
  };

  return context;
};

export const usePressureTraverseChartData = (
  scenarioCalculations: ScenarioCalculations,
  targetPressureUnit: ConvertableUnit,
  targetLargeLengthUnit: ConvertableUnit
): PressureTraverseChartData | undefined => {
  const context = buildPressureTraverseChartContext(
    scenarioCalculations,
    targetPressureUnit,
    targetLargeLengthUnit
  );

  if (!context) {
    return undefined;
  } else {
    const pressureTraverseDataSet = getPressureTraverseDataset(context);
    return {
      context,
      pressureTraverseDataSet
    };
  }
};
